import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;

  width: fit-content;
  max-width: 80%;
`

export const Avatar = styled.div`
  width: ${({ theme }) => theme.zds.size.variant210};
  height: ${({ theme }) => theme.zds.size.variant210};
  border-radius: 100%;
  background: linear-gradient(225deg, #061d38 14.64%, #1774de 85.36%);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: #fff;
  }
`

export const LoaderMessage = styled.div`
  width: ${({ theme }) => theme.zds.size.variant210};
  aspect-ratio: 4;
  background: ${({ theme }) => `radial-gradient(circle closest-side, ${theme.zds.colors.blue400} 90%, #0000) 0 /
    calc(100% / 3) 100% space`};
  clip-path: inset(0 100% 0 0);
  animation: l1 1s steps(4) infinite;

  @keyframes l1 {
    to {
      clip-path: inset(0 -34% 0 0);
    }
  }
`
